<mat-toolbar color="primary">
    <span>
        <img id="logo"
             src="favicon.ico"
             width="30"
             height="30"
             routerLink="/home" />
    </span>

    <span>
        <a class="company-name"
           routerLink="/home">Rendelő</a>
    </span>

    @if (isAuthenticated()) {
        @if (hasSelectedCeg()) {
            <span>
                <button mat-button
                        [matMenuTriggerFor]="menuSzemely">
                    Páciens törzs
                </button>
                <mat-menu #menuSzemely="matMenu">
                    <button mat-menu-item routerLink="/paciens">
                        <mat-icon>people</mat-icon>
                        <span>Páciensek</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item routerLink="/userProfile">
                        <mat-icon>voicemail</mat-icon>
                        <span>Felhasználó profilja</span>
                    </button>
                    <button mat-menu-item disabled>
                        <mat-icon>notifications_off</mat-icon>
                        <span>Számlázási csoportok</span>
                    </button>
                    <button mat-menu-item disabled>
                        <mat-icon>notifications_off</mat-icon>
                        <span>Rendelők</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item disabled>
                        <mat-icon>notifications_off</mat-icon>
                        <span>Árlisták</span>
                    </button>
                </mat-menu>
            </span>
            <span>
                <button mat-button
                        [matMenuTriggerFor]="menuBeallitasok">
                    Beállítások
                </button>
                <mat-menu #menuBeallitasok="matMenu">
                    <button mat-menu-item routerLink="/komplexum">
                        <mat-icon>business</mat-icon>
                        <span>Komplexumok</span>
                    </button>
                </mat-menu>
            </span>
        } @else if (!isOnSelectCegPage()) {
            <span class="ceg-selection-hint">
                A munka elkezdéséhez először válasszon ki egy céget →
            </span>
        }
    }
    <span class="fill-remaining-space"></span>
    @if (isAuthenticated() && !hasSelectedCeg() && !isOnSelectCegPage()) {
        <button mat-raised-button color="accent" (click)="navigateToCegSelection()" class="ceg-selection-button">
            Cégválasztás
        </button>
    }
    <rendelo-auth></rendelo-auth>
</mat-toolbar>
